<template>
<div class="header">
  <header :class="isExpanded">
    <div class="top-row">
      <div class="left">
        <v-btn @click="toggleDrawer" icon>
          <v-icon large class="menu">menu</v-icon>
        </v-btn>
        <img src="../assets/logo_white.png" alt="logo" class="logo">
      </div>
      <!-- <NotificationMenu /> -->
      <label class="organization" v-if="loggedIn">
        <select @change="setOrg" name="text" class="org-select">
          <option v-for= "org in orgs" :value="org._id" :key="org._id">
            {{org.name}}
          </option>
        </select>
        <v-icon>keyboard_arrow_down</v-icon>
      </label>
    </div>

    <div class="bottom-row" v-if="loggedIn">
      <v-btn
        color="secondary"
        @click="navBack"
        class="hero-button"
        v-if="currentProject"
        fab
      >
        <v-icon large class="plus">keyboard_backspace</v-icon>
      </v-btn>

      <v-btn
        color="secondary"
        @click="navBack"
        class="hero-button"
        v-else-if="this.$route.fullPath === '/account'"
        fab
      >
        <v-icon large class="plus">keyboard_backspace</v-icon>
      </v-btn>

      <v-tooltip bottom v-else>
        <v-btn
          color="secondary"
          @click="modal = true"
          class="hero-button"
          slot="activator"
          fab
        >
          <v-icon large class="plus">add</v-icon>
        </v-btn>
        <span>New Project</span>
      </v-tooltip>
      <PageTitle />
    </div>
    <FlashedMessages />
    <AddProjectModal
      :show-modal="modal"
      @close="modal = false"
    />
    <Drawer />
  </header>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InviteIcon from '../assets/noun_1159093_FFFFFF.svg';
import AddProjectModal from './AddProjectModal';
import FlashedMessages from './FlashedMessages.vue';
import PageTitle from './PageTitle';
import Drawer from './Drawer';

export default {
  name: 'AppHeader',
  components: {
    InviteIcon,
    AddProjectModal,
    Drawer,
    FlashedMessages,
    PageTitle,
  },
  data() {
    return {
      modal: false,
    };
  },
  computed: {
    ...mapState({
      orgs: state => state.orgs.data,
      currentProjectId: state => state.recordings.currentProjectId,
    }),
    ...mapGetters({
      inviteLink: 'orgs/inviteLink',
      openProjects: 'projects/openProjects',
      currentProject: 'projects/currentProject',
      loggedIn: 'users/loggedIn',
    }),
    isExpanded() {
      return this.loggedIn ? 'expanded' : '';
    },
  },
  methods: {
    toggleDrawer() {
      this.$emit('toggleDrawer', true);
    },
    setOrg(evt) {
      this.$store.dispatch('orgs/setOrg', evt.target.value);
    },
    addOrg() {
      this.$store.dispatch('projects/postOrg');
    },
    logout() {
      this.$store.dispatch('users/logout');
    },
    copyInviteLink() {
      this.$refs.inviteLink.select();
      document.execCommand('copy');
      this.$store.dispatch(
        'Notifications/flashMessage',
        { msg: 'copied to clipboard!', msgType: 'success' });
    },
    navBack() {
      const currentPathParams = this.$route.params;
      if (currentPathParams.recordingId) {
        return this.$router.push(`/project/${currentPathParams.projectId}`);
      }
      return this.$router.push('/');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  background-color: rgb(45, 61, 69);
  width: 100%;
}
header.expanded {
  height: 168px;
}
.hero-button {
  background-color: #17c68d;
}
p {
  color: #ffffff;
}
.extend-right {
  margin-left: auto;
}
.top-row {
  display: flex;
  flex-direction: row;
  height: 35%;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
}

.left {
  display: flex;
  align-items: center;
}

.bottom-row {
  display: flex;
  flex-direction: row;
  height: 65%;
  align-items: center;
  padding: 0px 20px;
}

.bell {
  margin-left: auto;
  font-size: 34px !important;
}
.menu, .bell {
  color: white !important;
}
.logo {
  margin-left: 50px;
  height: 30px;
}
.organization {
  display: block;
  margin-right: 30px;
  color: grey;
  font-size: 18px;
  position: relative;
}
.organization:after {
  position: absolute;
  right: 0;
}
.org-select {
  position: relative;
  padding-right: 30px;
  left: 30px;
}
.invite-link-contents {
  position: absolute;
  top: -30px;
}
.plus {
  height: 40px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue